import styled from 'styled-components'
import { em } from 'polished'

import { BoxBase } from 'styles/components/layout'
import { Text } from 'shared/Typography'

import bg from './assets/bg.png'
import bg_mob from './assets/bg_mob.png'

export const Wrapper = styled.div`
  padding-top: ${em(40)};
  padding-bottom: ${em(20)};
  background-color: #E3E1E1;
  background-image: url(${bg_mob});
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: right 102%;

  ${p => p.theme.mq.upMd} {
    background-image: url(${bg});
    background-size: 90%;
  }

  ${p => p.theme.mq.upLg} {
    padding-top: ${em(80)};
    padding-bottom: ${em(80)};
    background-size: contain;
  }
`

export const Container = styled(BoxBase)`
  display: flex;
  flex-direction: column;

  ${p => p.theme.mq.upLg} {
  }
`

export const Title = styled(Text)`
  margin-bottom: ${em(10, 25)};
  max-width: 50%;

  ${p => p.theme.mq.upLg} {
    max-width: ${em(406, 50)};
    margin-bottom: ${em(20, 50)};
  }

  span {
    color: var(--color-V50);
  }
`

export const Description = styled(Text)`
  margin-bottom: 72%;

  ${p => p.theme.mq.upLg} {
    max-width: ${em(517, 22)};
    margin-bottom: ${em(5, 22)};

    p {
      margin-bottom: ${em(30, 22)};

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`

export const Image = styled.img`
  display: block;
  max-width: 100%;
  ${p => p.theme.mq.upLg} {
    max-width: ${em(480)};

  }
`
